import { styled } from "styled-components";
import { StyledText } from "styles/Text";

const ProductListEmpty = () => {
  return (
    <StyledEmptyWrap>
      <StyledImgBox src={require("assets/images/img_no_content.png")} alt="" />
      <StyledText.Body16 as="p">
        상품을 불러올 수 없어요. <br />
        잠시 후 다시 시도해주세요.
      </StyledText.Body16>
    </StyledEmptyWrap>
  );
};

export default ProductListEmpty;

const StyledEmptyWrap = styled.div`
  display: flex;
  height: calc(
    100vh - 100px - 40px
  ); // 상단 타이틀+탭(100px) + 부모 하단 여백 (40px) 제외
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const StyledImgBox = styled.img`
  width: 96px;
  height: 96px;
  margin-bottom: 24px;
`;
